import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createLead = (data) => api.post("/leads", data).then((r) => r.data);

export const transformPhoto = (file, goalKg) => {
  const form = new FormData();
  form.append("image", file);
  form.append("goal_kg", goalKg);
  return api
    .post("/transform", form, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};
